import React, { Component } from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';

class PhotoEditor extends Component {
    render() {
        return (
            <div className={this.props.className}>
                <div className="react-avatar-custom-slider-container">
                    <p className="react-avatar-custom-slider-text">
                        {this.props.text}
                    </p>
                    <Slider
                        {...this.props}
                        onChange={this.props.onChange}
                        className="react-avatar-custom-slider-slider"
                    />
                </div>
            </div>
        );
    }
}

export default PhotoEditor;



// WEBPACK FOOTER //
// ./src/Components/CustomSlider.js